import { render, staticRenderFns } from "./t-keyword.vue?vue&type=template&id=1bff1096&"
import script from "./t-keyword.vue?vue&type=script&lang=js&"
export * from "./t-keyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports